import { BlueprintRepository } from "./blueprint-repository";

export const getAuthor = () => {
  const repo = new BlueprintRepository();
  return repo.getAuthor();
};
